import {Injectable} from '@angular/core';
import {SocketConsumer} from '@socket-factory/client';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  chatSocket?: SocketConsumer;
  private messageSubject = new Subject<any>();

  constructor() {
  }

  connect() {
    if (!this.chatSocket) {
      this.chatSocket = new SocketConsumer(
        `/data_management_app/ws/upload_files/`,
        {
          autoConnect: true,
          autoReconnect: true,
        },
        {
          reconnectInterval: 5000,
          maxReconnects: 10,
        }
      );

      this.chatSocket.onMessage = (event) => {
        this.messageSubject.next(JSON.parse(event.data));
      };

      this.chatSocket.onError = (event) => {
        console.error('WebSocket error:', event);
      };

      this.chatSocket.onClose = (event) => {
        console.info('WebSocket connection closed:', event);
      };
    }
  }

  disconnect() {
    if (this.chatSocket) {
      this.chatSocket.close();
      this.chatSocket = undefined;
      console.info('WebSocket connection manually closed.');
    }
  }


  getMessages() {
    return this.messageSubject.asObservable();
  }
}
